import { useHasSpaceForBranding, useIsSmall } from './mediaQueries';
import useGlobalContext from '../../../Pages/Home/Context';

interface LogoPositions {
  inNavigation?: boolean;
  rightOfPdf?: boolean;
  belowPdf?: boolean;
  inSuccessMessage?: boolean;
}

const useLogoPosition = (canOpenNavigation: boolean): LogoPositions => {
  const { openMenu } = useGlobalContext();
  const hasSpace = useHasSpaceForBranding();
  const isSmall = useIsSmall();

  if (canOpenNavigation && !isSmall) {
    return { inNavigation: true, inSuccessMessage: !!openMenu };
  }

  if (openMenu) {
    return { inNavigation: true, belowPdf: true, inSuccessMessage: true };
  }

  if (hasSpace) {
    return { inNavigation: true, rightOfPdf: true };
  }

  return { inNavigation: true, belowPdf: true };
};

export default useLogoPosition;
